module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"username":"Benutzername"},"en":{"username":"Username"}}')
  delete Component.options._Ctor
}
